module.exports = __webpack_public_path__ + "img/office_tipo.46ae7c22.svg";